// YunEmFlex.js

import { memo } from 'react'
import './YunEmFlex.css';

import YunIcon from '../YunIcon/YunIcon';

import Slider from '@material-ui/core/Slider';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputBox from '../InputBox/InputBox';

import { sliderConfig, formatShowValue } from '../YunEmFineTune/tool';

const YunEmFlex = memo(function YunEmFlex({emFlexVal, handleEmFlex, emFlex, flexPreset}){

    const labelValue = formatShowValue(emFlexVal, flexPreset)

    if (!emFlex) {
        return null
    }
    const MenuItemEle = []
    flexPreset.forEach((ele, index) => {
        MenuItemEle.push(
            <MenuItem className="SelectItem" value={ele.value} key={'flex-item-' + index}>
                {ele.name}
            </MenuItem>
        )
    })

    return (
        <div className="YunCommonLayoutWrapper">
            <div className="YunEmFlex YunCommonLayout">
                <div className="Label CursorDefault">
                    弹性：
                </div>
                <Slider
                    value={emFlexVal}
                    onChange={(e, val) => handleEmFlex(val)}
                    min={sliderConfig.min}
                    max={sliderConfig.max} />
                <div className="RateSelect">
                    <div className="RateSelectLabel HoverColor MainColor">{labelValue}</div>
                    <YunIcon iconClass="MainColor HoverColor" icon="expand"></YunIcon>
                    <Select value="" onChange={(e, child) => handleEmFlex(child.props.value)}>
                        {MenuItemEle}
                        <InputBox val={emFlexVal} min={0} max={100} step={1} onChange={handleEmFlex} >
                        </InputBox>
                    </Select>
                </div>
            </div>
        </div>
    )
})

export default YunEmFlex;
